import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

import { IncentivesMarketBeneficiary } from '../types';

type GetIncentiveOfferBeneficiaryPublicInfoProps = {
  incentiveOfferId: string;
  signal?: AbortSignal;
};

export type BeneficiaryPublicInfo = Pick<
  IncentivesMarketBeneficiary,
  '_id' | 'name' | 'image' | 'sharesCount'
> & {
  invitationDate?: string;
};

export const getIncentiveOfferBeneficiaryPublicInfo = async ({
  incentiveOfferId,
}: GetIncentiveOfferBeneficiaryPublicInfoProps): Promise<BeneficiaryPublicInfo> => {
  const { data } = await axiosV2.get(
    `/incentiveOffers/beneficiary-public-info/${incentiveOfferId}`
  );

  const decodedData = (await decryptResponse(data)) as BeneficiaryPublicInfo;
  return decodedData;
};
